var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-item gary"},[_c('div',{staticClass:"content-items"},[_c('p',{staticClass:"title"},[_vm._v("About Us")]),_c('div',{staticClass:"contentList"},_vm._l((_vm.contentList),function(item,index){return _c('span',{key:index,staticClass:"content-item"},[_vm._v(" "+_vm._s(item.content)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }